import script from "./ChatListPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatListPanel.vue?vue&type=script&setup=true&lang=js"

import "./ChatListPanel.vue?vue&type=style&index=0&id=15ecb1ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ecb1ea"]])

export default __exports__